import * as React from 'react';
import { CircularProgress } from '@mui/material';

const HomepageLoader: React.FC = () => (
  <div className="flex items-center justify-center w-full h-full">
    <CircularProgress size="10rem" color="primary" />
  </div>
);

export default HomepageLoader;
